/**
 * Central tuning constants for NEON DRIFT. Gameplay speed values are in world
 * units per second; distances in world units (1u ~ 1m). The moving-world model
 * keeps the bike near z=0 and slides everything toward +Z.
 */
export const LANES = [-1, 0, 1] as const;
export const LANE_WIDTH = 2.35;

export const TRACK = {
  /** Half-width of the deck (covers 3 lanes plus shoulders). */
  halfWidth: (LANE_WIDTH * 3) / 2 + 0.9,
  /** How far ahead of the player content spawns. */
  spawnZ: -150,
  /** Where content is recycled once it passes behind the camera. */
  despawnZ: 14,
  segmentLength: 12,
  segmentCount: 16,
};

export const SPEED = {
  base: 16,
  /** Base speed gain per second of active play. */
  ramp: 0.22,
  /** Hard cap on base speed. */
  maxBase: 42,
  /** Extra speed added per collected cell. */
  cellBoost: 2.6,
  /** Cap on the decaying boost pool. */
  maxBoost: 13,
  /** Boost pool decay per second. */
  boostDecay: 1.6,
  /** Overdrive speed multiplier. */
  overdriveMultiplier: 1.28,
};

export const RUN = {
  laneChangeDuration: 0.16,
  crashSlowmoScale: 0.25,
  crashSlowmoDuration: 1.1,
  nearMissWindow: 1.6,
  nearMissBonus: 40,
  cellScore: 25,
  overdrivePerCell: 0.12,
  overdriveDuration: 6,
  /** Score per meter travelled. */
  distanceScore: 1,
};

export type DebugTuning = {
  exposure: number;
  maxDpr: number;
  bloom: number;
  cameraLag: number;
  fov: number;
};

export const DEFAULT_TUNING: DebugTuning = {
  exposure: 1.12,
  maxDpr: 2,
  bloom: 0.6,
  cameraLag: 0.11,
  fov: 46,
};

export type GameState = 'title' | 'running' | 'paused' | 'gameover';
